import Privacy from './privacy'
export default Privacy
